import { PublicWebPage } from '@/features/public-web/PublicWebPage';
import { PublicWebPanel } from '@/features/public-web/PublicWebPanel';
import { PublicWebPanelBody } from '@/features/public-web/PublicWebPanelBody';
import { PublicWebPanelTitle } from '@/features/public-web/PublicWebPanelTitle';
import { publicWebURLs } from '@/features/public-web/publicWebURLs';
import { APP_CONFIG } from '@/lib/app/config';

export default function SupportWebScreen() {
  return (
    <PublicWebPage
      eyebrow="Support"
      title="Need a hand? Send the cleanest signal."
      body="If something feels off with your account, a link, a venue, or the app, reach us directly and include the page or email you used."
      actions={[
        { label: `Email ${APP_CONFIG.supportEmail}`, href: publicWebURLs.supportEmail },
        { label: 'Browse help docs', href: 'https://docs.radious.app/help', variant: 'secondary' },
      ]}>
      <PublicWebPanel tone="accent">
        <PublicWebPanelTitle>App support</PublicWebPanelTitle>
        <PublicWebPanelBody>
          We can help with sign-in issues, App Store download problems, broken links, account
          questions, and bugs that get in the way of using Radious.
        </PublicWebPanelBody>
      </PublicWebPanel>
      <PublicWebPanel>
        <PublicWebPanelTitle>Venue support</PublicWebPanelTitle>
        <PublicWebPanelBody>
          If you manage a venue, include the venue name and the Backstage account email so we can
          find the right workspace faster.
        </PublicWebPanelBody>
      </PublicWebPanel>
      <PublicWebPanel>
        <PublicWebPanelTitle>Legal and privacy</PublicWebPanelTitle>
        <PublicWebPanelBody>
          Privacy requests can be sent to privacy@radious.app. Terms and privacy pages now live in
          Radious Docs as the canonical source.
        </PublicWebPanelBody>
      </PublicWebPanel>
    </PublicWebPage>
  );
}
